import classNames from "classnames";
import { Header } from "components/atoms/Typography";
import { IncreaseDecreasePercentage } from "components/molecules/Card/CardFunctions";
import { ValueType } from "components/molecules/Card/CardTypes";
import errorFallbackUI from "components/molecules/ErrorFallbackUI.tsx/ErrorFallbackUI";
import { ComponentErrorBoundary } from "components/molecules/ErrorStates";
import usePlansState from "recoilStore/Building/usePlansState";
import { displayValueWithUnit, getDisplayInfo } from "utils/formatting";
import prepareCarbonPenaltiesCardData from "./CarbonPenalties.helper";
import CarbonPenaltiesChart from "./CarbonPenaltiesChart/CarbonPenaltiesChart";

function CarbonPenaltiesCard() {
    const { referencePlan, comparedPlan, referencePlanName, comparedPlanName, comparingToBaseline } = usePlansState();

    const { cardHeaderData, tooltipElement } = prepareCarbonPenaltiesCardData(
        referencePlan,
        comparedPlan,
        referencePlanName,
        comparedPlanName
    );
    const { value, displayInfoKey } = cardHeaderData[0];

    const { unit, formatFunction } =
        typeof value === "number" ? getDisplayInfo(displayInfoKey, value) : getDisplayInfo(displayInfoKey);

    return (
        <div className={classNames("card", "card-with-chart-container")}>
            <ComponentErrorBoundary fallback={errorFallbackUI("cardHeaderError")} originComponent="Card">
                <Header>Carbon Policies Savings</Header>
                <div className="card__value-and-percentage">
                    <Header>
                        {displayValueWithUnit(
                            cardHeaderData[0].value,
                            unit,
                            (v: ValueType) => formatFunction(v) ?? String(v)
                        )}
                    </Header>
                    {typeof cardHeaderData[0].increaseDecreasePercentage === "number" && !comparingToBaseline && (
                        <IncreaseDecreasePercentage
                            isHeader={true}
                            value={cardHeaderData[0].increaseDecreasePercentage}
                            invertedColor={true}
                            tooltipElement={tooltipElement}
                        />
                    )}
                </div>
            </ComponentErrorBoundary>
            <CarbonPenaltiesChart />
        </div>
    );
}

export default CarbonPenaltiesCard;
